export default "__VITE_ASSET__CMILunBF__"